import axios from "axios";
import apiClient from "./axiosConfig";
import { websiteApi } from "./base";

export async function resolve(promise) {
  try {
    const data = await promise;
    return { data: data.data, error: null };
  } catch (e) {
    return {
      data: null,
      error: e.response ? e.response.data : e.message,
    };
  }
}

export async function sentDetails(data) {
  const form = {
    parentName: data.name,
    childAge: data.service,
    phoneNumber: data.phone,
    phoneCountry: data.phoneCountry,
    message: data.message,
    emailAddress: data.email,
  };
  const response = await axios.post(websiteApi("/contact-us"), form, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
}

export async function sentNewsletter(data) {
  const form = {
    email: data.email,
  };
  const response = await axios.post(websiteApi("/news-letter"), form, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
}

export const GetAllNewsLetters = () => axios.get(websiteApi("/newsletter"));

export const GetAllBlogs = () => axios.get(websiteApi("/get_blog"));

export const GetSearchBlogs = (text) =>
  axios.get(websiteApi(`/get_blog/?search_text=${text}`));

export const GetOneBlog = (id) => axios.get(websiteApi(`/blog/${id}`));

export const CreateComment = (data, id) =>
  axios.post(websiteApi(`/comments/blog/${id}`), data);

export const GetAllEvents = () =>
  axios.get(websiteApi("/marketing-events"));

export const GetAllTestimonials = () =>
  axios.get(websiteApi("/testimonial"));

export const CreateTestimonial = (data) =>
  axios.post(websiteApi("/testimonial/create"), data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const DownloadInfographic = (data) =>
  apiClient.post(`/wb-infographic`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

export const DeleteAccount = (data) =>
  apiClient.post(`/delete-account`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
